(( $, wp ) => {

    const { __, _x, _n, _nx } = wp.i18n;
    const { Fragment } = wp.element;
    const { SelectControl, TextControl, PanelBody, PanelRow } = wp.components;
    if (typeof wp.blockEditor != "undefined") var { InspectorControls } = wp.blockEditor;
    else var { InspectorControls } = wp.editor;


    wp.blocks.registerBlockType( 'discord-wordpress-plugin/dwpp-sharing-gutenberg-block', {

        // Block setup
        title: __('Discord Sharing Button', 'discord-wordpress-plugin'),
        description: __('Block outputs an HTML link for sharing to Discord guild.', 'discord-wordpress-plugin'),
        icon: <svg width="430" height="430" viewBox="0 0 430 430">
                <path fill="#da727a" d="M295.766 0C259.738 0 230.531 29.2074 230.531 65.2349C230.531 66.7566 230.654 68.2469 230.762 69.741L110.254 126.301C98.5432 115.111 82.7099 108.202 65.236 108.202C29.2075 108.203 0 137.41 0 173.438C0 209.466 29.2075 238.673 65.2353 238.673C76.6005 238.673 87.2848 235.752 96.5879 230.645L148.749 274.597C146.465 281.246 145.17 288.346 145.17 295.765C145.17 331.793 174.378 361 210.405 361C246.434 361 275.641 331.793 275.641 295.765C275.641 259.738 246.434 230.53 210.405 230.53C199.041 230.53 188.356 233.451 179.052 238.557L126.891 194.606C129.176 187.961 130.471 180.857 130.471 173.438C130.471 171.917 130.348 170.43 130.24 168.932L250.748 112.372C262.458 123.561 278.292 130.47 295.765 130.47C331.792 130.47 361 101.263 361 65.2356C361 29.2081 331.794 0 295.766 0Z"/>
                <path fill="white" d="M415 238H238V383H415V238Z"/>
                <path fill="#7289DA" d="M355.17 317.14C355.167 319.976 354.041 322.696 352.037 324.703C350.034 326.71 347.316 327.842 344.48 327.85C341.625 327.813 338.894 326.674 336.86 324.67C335.874 323.698 335.094 322.538 334.566 321.258C334.039 319.978 333.775 318.604 333.79 317.22C333.793 314.384 334.919 311.664 336.923 309.657C338.926 307.649 341.644 306.518 344.48 306.51C345.88 306.506 347.267 306.778 348.562 307.31C349.857 307.842 351.034 308.624 352.027 309.611C353.019 310.598 353.808 311.771 354.347 313.063C354.886 314.355 355.166 315.74 355.17 317.14ZM307.7 306.47C306.292 306.473 304.899 306.752 303.599 307.294C302.3 307.835 301.119 308.627 300.126 309.624C299.132 310.621 298.345 311.804 297.808 313.106C297.272 314.408 296.997 315.802 297 317.21C296.985 318.594 297.249 319.968 297.776 321.248C298.304 322.528 299.084 323.688 300.07 324.66C302.104 326.664 304.835 327.803 307.69 327.84C310.525 327.84 313.244 326.714 315.249 324.709C317.254 322.704 318.38 319.985 318.38 317.15C318.38 314.315 317.254 311.596 315.249 309.591C313.244 307.586 310.525 306.46 307.69 306.46L307.7 306.47ZM430 237.17V430L404.72 409.64L390.89 397.64L375.74 385.12L382 404.88H249.65C236.44 404.88 225.65 395.31 225.65 382.71V237.22C225.65 225.22 236.39 215.05 249.65 215.05H405.37C418.66 215 429.34 225.18 430 237.17ZM347.27 266L347.59 265.91H347.36L347.27 266ZM396.76 340.23C396.76 305.58 379.63 277.36 379.63 277.36C364.31 266.56 350.01 266.08 347.31 266.08L345.57 267.71C365.13 273.09 374.57 281.47 374.57 281.47C361.074 274.949 346.385 271.265 331.409 270.644C316.433 270.023 301.489 272.479 287.5 277.86C283.07 279.67 280.55 280.86 280.55 280.86C280.55 280.86 289.97 271.86 310.81 267.1L309.53 265.91C309.53 265.91 293.71 265.34 276.71 277.28C276.71 277.28 259.66 305.41 259.82 340.28C259.82 340.28 269.24 355.89 295.11 356.46C295.11 356.46 298.86 351.65 302.7 347.46C288.16 343.27 282.5 334.89 282.5 334.89L287.35 337.27C301.56 342.82 316.6 349.83 343.35 345.64C348.97 344.41 354.64 343.22 360.35 340.84C364.02 339.03 368.54 337.23 373.52 334.23C373.52 334.23 367.87 342.61 352.73 346.8C355.84 350.99 360.23 355.8 360.23 355.8C386.16 355.19 396.22 339.61 396.77 340.24L396.76 340.23Z"/>
            </svg>,
        category: 'discord-wordpress-plugin-blocks',


        // Custom attributes
        attributes: {
            text: {
                type: 'string',
                default: __('Share on Discord', 'discord-wordpress-plugin'),
            },
            styling: {
                type: 'string',
                default: 'no',
            }
        },


        // Main editor function
        edit: props => {

            return [

                // Sidebar controls
                <Fragment>
                    <InspectorControls>
                        <PanelBody title={'View'} initialOpen={true}>
                            <PanelRow>
                                <TextControl
                                    label={ __('Button text', 'discord-wordpress-plugin') }
                                    value={ props.attributes.text }
                                    onChange={ value => props.setAttributes({ text: value }) }/>
                            </PanelRow>
                            <PanelRow>
                                <SelectControl
                                    label={ __('Style', 'discord-wordpress-plugin') }
                                    onChange={ value => props.setAttributes({ styling: value }) }
                                    options={[
                                        { value: 'no', label: __('None', 'discord-wordpress-plugin') },
                                        { value: 'default', label: __('Default', 'discord-wordpress-plugin') }
                                    ]}
                                    value={ props.attributes.styling }/>
                            </PanelRow>
                        </PanelBody>
                    </InspectorControls>
                </Fragment>,

                // Output in editor
                <a className={"dwpp__share dwpp__button--" + props.attributes.styling + "-style"} href="javascript:void(0)">
                    { props.attributes.text }
                </a>
            ];
        },


        // Front end save
        save: () => {
            return null;
        },

    });
})( jQuery, wp );
